import { Action } from '@ngrx/store';

import * as fromModels from '../models';

import { ICognitoUserData } from 'amazon-cognito-identity-js';

const PREFIX = '[UI]';

export const SET_CURRENT_USER = `${PREFIX} Set Current User`;

// Taxonomy touchpoint
export const GET_TOUCHPOINT_PORTION = `${PREFIX} Get Touchpoint Portion`;
export const SET_TOUCHPOINT_PORTION = `${PREFIX} Set Touchpoint Portion`;
export const SAVE_TOUCHPOINT_PORTION = `${PREFIX} Save Touchpoint Portion`;

// Taxonomy goal
export const GET_GOAL_PORTION = `${PREFIX} Get Goal Portion`;
export const SET_GOAL_PORTION = `${PREFIX} Set Goal Portion`;
export const SAVE_GOAL_PORTION = `${PREFIX} Save Goal Portion`;

// Taxonomy trigger
export const GET_TRIGGER_PORTION = `${PREFIX} Get Trigger Portion`;
export const SET_TRIGGER_PORTION = `${PREFIX} Set Trigger Portion`;
export const SAVE_TRIGGER_PORTION = `${PREFIX} Save Trigger Portion`;

// Taxonomy category
export const GET_CATEGORY_PORTION = `${PREFIX} Get Category Portion`;
export const SET_CATEGORY_PORTION = `${PREFIX} Set Category Portion`;
export const SAVE_CATEGORY_PORTION = `${PREFIX} Save Category Portion`;

// Languages
export const GET_LANGUAGES_PORTION = `${PREFIX} Get Languages Portion`;
export const SET_LANGUAGES_PORTION = `${PREFIX} Set Languages Portion`;

// Countries
export const GET_COUNTRIES_PORTION = `${PREFIX} Get Countries Portion`;
export const SET_COUNTRIES_PORTION = `${PREFIX} Set Countries Portion`;

export class SetCurrentUser implements Action {
  readonly type = SET_CURRENT_USER;
  constructor(public payload: ICognitoUserData & { userId: string }) {}
}

// -----------------------------------------------------------------
// Taxonomy touchpoint

export class GetTouchpointPortion implements Action {
  readonly type = GET_TOUCHPOINT_PORTION;
  constructor(public payload: fromModels.TouchpointPortionPayloadType) {}
}

export class SetTouchpointPortion implements Action {
  readonly type = SET_TOUCHPOINT_PORTION;
  constructor(public payload: fromModels.TouchpointSavePayloadType) {}
}

export class SaveTouchpointPortion implements Action {
  readonly type = SAVE_TOUCHPOINT_PORTION;
  constructor(public payload: fromModels.TouchpointSavePayloadType) {}
}

// -----------------------------------------------------------------

// -----------------------------------------------------------------
// Taxonomy goal

export class GetGoalPortion implements Action {
  readonly type = GET_GOAL_PORTION;
  constructor(public payload: fromModels.GoalPortionPayloadType) {}
}

export class SetGoalPortion implements Action {
  readonly type = SET_GOAL_PORTION;
  constructor(public payload: fromModels.GoalSavePayloadType) {}
}

export class SaveGoalPortion implements Action {
  readonly type = SAVE_GOAL_PORTION;
  constructor(public payload: fromModels.GoalSavePayloadType) {}
}

// -----------------------------------------------------------------

// -----------------------------------------------------------------
// Taxonomy trigger

export class GetTriggerPortion implements Action {
  readonly type = GET_TRIGGER_PORTION;
  constructor(public payload: fromModels.TriggerPortionPayloadType) {}
}

export class SetTriggerPortion implements Action {
  readonly type = SET_TRIGGER_PORTION;
  constructor(public payload: fromModels.TriggerSavePayloadType) {}
}

export class SaveTriggerPortion implements Action {
  readonly type = SAVE_TRIGGER_PORTION;
  constructor(public payload: fromModels.TriggerSavePayloadType) {}
}

// -----------------------------------------------------------------

// -----------------------------------------------------------------
// Languages

export class GetLanguagesPortion implements Action {
  readonly type = GET_LANGUAGES_PORTION;
  constructor(public payload: fromModels.LanguagePortionPayloadType) {}
}

export class SetLanguagesPortion implements Action {
  readonly type = SET_LANGUAGES_PORTION;
  constructor(public payload: { portions: fromModels.ILanguageState[] }) {}
}

// -----------------------------------------------------------------

// -----------------------------------------------------------------
// Countries

export class GetCountriesPortion implements Action {
  readonly type = GET_COUNTRIES_PORTION;
  constructor(public payload: fromModels.CountryPortionPayloadType) {}
}

export class SetCountriesPortion implements Action {
  readonly type = SET_COUNTRIES_PORTION;
  constructor(public payload: { portions: fromModels.ICountryState[] }) {}
}

// -----------------------------------------------------------------

export type All =
  | SetCurrentUser
  | GetTouchpointPortion
  | SetTouchpointPortion
  | SaveTouchpointPortion
  | GetGoalPortion
  | SetGoalPortion
  | SaveGoalPortion
  | GetTriggerPortion
  | SetTriggerPortion
  | SaveTriggerPortion
  | GetLanguagesPortion
  | SetLanguagesPortion
  | GetCountriesPortion
  | SetCountriesPortion;



// WEBPACK FOOTER //
// ./src/app/shared/store/actions/ui.actions.ts